export default {
  notes: (state, getters, rootState, rootGetters) => {
    return state.notes;
  },
  hasNote: (state, getters, rootState, rootGetters) => memoId => {
    return getters.notes.some(n => n.memoId === memoId);
  }
};
